module.exports = __webpack_public_path__ + "static/media/445873413_1432465530726871_3210772881523236194_n.f0f0a95c.jpg";